export const UPDATE_MULTIPLE_STOPS_CLASSIFICATION =
  'UPDATE_MULTIPLE_STOPS_CLASSIFICATION';
export const UPDATE_MULTIPLE_STOPS_CLASSIFICATION_SUCCESS =
  'UPDATE_MULTIPLE_STOPS_CLASSIFICATION_SUCCESS';
export const UPDATE_MULTIPLE_STOPS_CLASSIFICATION_ERROR =
  'UPDATE_MULTIPLE_STOPS_CLASSIFICATION_ERROR';
